import { axiosGet } from "../../Helpers/AxiosHelper";

export const GetUsersData = async ({ url, setLoading }) => {
  setLoading && setLoading(true);
  let response = await axiosGet({ url, withSNo: false });
  setLoading && setLoading(false);

  let data = response.data?.data;
  let forSelect = data?.map((item) => ({
    label: item.fullName,
    mail: item.email,
    email: item.email,
    image: item.profileImage?.path || item.profileImage,
    value: item.id,
  }));

  return { data, forSelect };
};
